module.exports = __webpack_public_path__ + "images/people/man-woman-IT@2x-8179d64574c4343a87c55e8f63ee1c43.webp";